"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeList = void 0;

/**
 *
 * @param {string} property
 * @param {[]} list
 * @param {[{name: string, path: string, toLower: boolean}]} mapProps - max depth of 5
 * @return {*}
 */
var normalizeList = function normalizeList(property, list) {
  var mapProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var rObj = {
    entities: {},
    ids: []
  };

  if (mapProps && Array.isArray(mapProps)) {
    mapProps.forEach(function (obj) {
      rObj[obj.name] = {};
    });
  } // eslint-disable-next-line func-names


  rObj.toArray = function () {
    var arr = [];

    for (var i = 0; i < this.ids.length; i += 1) {
      arr.push(this.entities[this.ids[i]]);
    }

    return arr;
  };

  if (!property || !list || !list.length) {
    return rObj;
  }

  list.forEach(function (obj) {
    rObj.ids.push(obj[property]);
    rObj.entities[obj[property]] = obj;

    if (mapProps && Array.isArray(mapProps)) {
      mapProps.forEach(function (mapObj) {
        var pathArr = mapObj.path.split('.');

        switch (pathArr.length) {
          case 1:
            if (obj[pathArr[0]]) {
              rObj[mapObj.name][mapObj.toLower ? obj[pathArr[0]].toLowerCase() : obj[pathArr[0]]] = obj[property];
            }

            break;

          case 2:
            if (obj[pathArr[0]][pathArr[1]]) {
              rObj[mapObj.name][mapObj.toLower ? obj[pathArr[0]][pathArr[1]].toLowerCase() : obj[pathArr[0]][pathArr[1]]] = obj[property];
            }

            break;

          case 3:
            if ([pathArr[0]][pathArr[1]][pathArr[2]]) {
              rObj[mapObj.name][mapObj.toLower ? obj[pathArr[0]][pathArr[1]][pathArr[2]].toLowerCase() : obj[pathArr[0]][pathArr[1]][pathArr[2]]] = obj[property];
            }

            break;

          case 4:
            if ([pathArr[0]][pathArr[1]][pathArr[2]][pathArr[3]]) {
              rObj[mapObj.name][mapObj.toLower ? obj[pathArr[0]][pathArr[1]][pathArr[2]][pathArr[3]].toLowerCase() : obj[pathArr[0]][pathArr[1]][pathArr[2]][pathArr[3]]] = obj[property];
            }

            break;

          case 5:
            if (obj[pathArr[0]][pathArr[1]][pathArr[2]][pathArr[3]][pathArr[4]]) {
              rObj[mapObj.name][mapObj.toLower ? obj[pathArr[0]][pathArr[1]][pathArr[2]][pathArr[3]][pathArr[4]].toLowerCase() : obj[pathArr[0]][pathArr[1]][pathArr[2]][pathArr[3]][pathArr[4]]] = obj[property];
            }

            break;

          default:
            break;
        }
      });
    }
  });
  return rObj;
};

exports.normalizeList = normalizeList;